module.exports = __webpack_public_path__ + "static/media/signage-indoor-img28.4c441e9f.jpg";